<template>
  <b-modal :id="modalId" centered @shown="show" @ok="confirm" hide-header @hidden="hidden">
    <div class="d-block text-center">
      <Icon name="grAlertTriangle" width="36" class="mb-3"/>
      <h1 class="modal-title mb-2">{{ title }}</h1>
      <h2 v-if="bodyTitle" class="modal-subtitle mb-3">{{ bodyTitle }}</h2>
      <p class="modal-subtitle">{{ bodyText }}</p>
    </div>
    <template #modal-footer="{ ok, cancel }">
      <div class="row w-100 justify-content-center">
        <div class="col-sm-6">
          <b-button variant="primary" block @click="cancel()">{{ okBtnLabel }}</b-button>
        </div>
      </div>
    </template>

  </b-modal>
</template>

<script>
export default {
  props: {
    modalId: {type: String, required: true},
    title: {type: String, required: true},
    bodyTitle: {type: String, required: false},
    bodyText: {type: String, required: true},
    okBtnLabel: {type: String, required: false, default: 'Ok'}
  },

  methods: {
    show() {
      this.$emit('shown')
    },

    confirm() {
      this.$emit('confirm')
    },

    hidden() {
      this.$emit('hidden')
    }
  }
}
</script>
